export default __webpack_public_path__ + "static/media/DAI.849478a7.png";